import React, { useRef, useEffect } from 'react';

const CurvedLinesCanvas = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const width = canvas.width = canvas.offsetWidth;
    const height = canvas.height = canvas.offsetHeight;

    const lineColor = 'rgba(85, 9, 201, 0.8)'; 
    const glowColor = 'rgba(85, 9, 201, 0.5)'; 

    const drawSymmetricLines = () => {
      ctx.strokeStyle = lineColor;
      ctx.lineWidth = 1; 
      ctx.shadowColor = glowColor; 

      const lineCount = 50; 
      const startPointX = 0; 
      const spacingX = width / lineCount; 
      const spacingY = 10; 

      for (let i = 0; i < lineCount; i++) {
        const startX = width - i * spacingX; 
        const startY = height; 
        const endX = 0; 
        const endY = height - (i + 1) * spacingY; 

        ctx.beginPath();
        ctx.moveTo(startX, startY);
        ctx.lineTo(endX, endY);
        ctx.stroke();
      }
    };

    ctx.clearRect(0, 0, width, height);

    // Dessiner les traits symétriques
    drawSymmetricLines();
  }, []);

  return <canvas ref={canvasRef} className="curved-lines-canvas"></canvas>;
};

export default CurvedLinesCanvas;
